import { CS } from "../../../base/utils/styler"

export const baseStyle: CS = {
    border: '3px dashed #ddd',
    borderRadius: '10px',
    padding: '10px',
    margin: '20px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    background: '#fafafa',
    minWidth: '500px',
    opacity: '0.5',
    pointerEvents: 'none',
    '&:hover': {
        borderColor: '#667eea',
        background: '#f5f5ff',
    },
    '&.dragover': {
        borderColor: '#667eea',
        background: '#f0f0ff',
        transform: 'scale(1.02)',
    },
}

export const iconStyle: CS = {
    fontSize: '48px',
    color: '#667eea',
    marginBottom: '20px',
}

export const textStyle: CS = {
    color: '#666',
    fontSize: '16px',
    margin: '10px',
}

export const hintStyle: CS = {
    color: '#999',
    fontSize: '14px',
}